"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshResponseSchema = exports.RefreshRequestSchema = exports.LoginResponseSchema = exports.AuthUserSchema = exports.LoginRequestSchema = void 0;
const zod_1 = require("zod");
exports.LoginRequestSchema = zod_1.z.object({
    loginName: zod_1.z.string().min(1).max(100),
    password: zod_1.z.string().min(1).max(256),
});
exports.AuthUserSchema = zod_1.z.object({
    staffId: zod_1.z.number(),
    loginName: zod_1.z.string(),
    employeeId: zod_1.z.number().nullable(),
    orgId: zod_1.z.number().nullable(),
    orgName: zod_1.z.string().nullable(),
    fullName: zod_1.z.string().nullable(),
    avatarPath: zod_1.z.string().nullable(),
    roles: zod_1.z.array(zod_1.z.string()),
    permissions: zod_1.z.array(zod_1.z.string()),
});
exports.LoginResponseSchema = zod_1.z.object({
    accessToken: zod_1.z.string(),
    refreshToken: zod_1.z.string(),
    user: exports.AuthUserSchema,
});
exports.RefreshRequestSchema = zod_1.z.object({
    refreshToken: zod_1.z.string().min(10),
});
exports.RefreshResponseSchema = zod_1.z.object({
    accessToken: zod_1.z.string(),
    refreshToken: zod_1.z.string(),
});
